<template>
    <div class="box-card">
        <el-card shadow="hover">
			<div slot="header" class="clearfix p-pointer" @click="setPackUp">
				<h4>往期得分 ( {{ListByStaff.length}} )</h4>
			</div>
            <div class="card-list" ref="histor">
                <el-row>
                    <el-col :span="18">考核期</el-col>
                    <el-col :span="6">得分</el-col>
                </el-row>
                <br/>
                <el-row v-for="item in ListByStaff" :key="item.id" @click="listClick(item)" :class="{active:date === item.start_date}">
                    <div class="pointer" @click="listClick(item)">
                        <el-col :span="18">{{item.start_date}}-{{item.end_date}}</el-col>
                        <el-col :span="6">{{item.total_score?item.total_score:0}}</el-col>
                    </div>
                </el-row>
            </div>
		</el-card>
    </div>
</template>
<script>
import { computeAssessDate } from '@/assets/js/date.js'
export default {
    data(){
        return {
            ListByStaff:[],
            date:'',
        }
    },
    created(){
        // this.initData(this.$store.state.login.userinfo.id)
    },
    methods:{
        initData(id){
            this.ListByStaff=[];
            this.date=computeAssessDate()[0].split('/')[0];
            const params={
                params:{
                    staff_id:id
                }
            }
            this.$http.get('assessment/getListByStaffId',params).then((v)=>{
                const start_date = computeAssessDate()[0].split('/')[0]
                const ListByStaffData = v.data.filter(item =>  start_date >= item.start_date)
                this.ListByStaff=ListByStaffData.reverse()
            }).catch(()=>{})
        },
        listClick({start_date,end_date}){
            this.date=start_date;
            const param={
                start:start_date,
                end:end_date,
            }              
            this.$emit('historical',param);
        },
        setPackUp() {
            const el = this.$refs.histor.parentElement.style;
            if(el.display === '' || el.display === 'block') {
                el.display = 'none';
            }else{
                el.display = 'block';
            }
        }
    }
}
</script>
<style scoped>
.box-card{
	width: 400px;
    padding: 10px;
    position: absolute;
    top: -3px;
    right: 0px;
}
.card-list{
    max-height: 700px;
    overflow-y: auto;
}
.pointer:hover{
    background: #f0f2f5;
}
.active{
    background: #f0f2f5;
}
.pointer{ 
    cursor:pointer;
    padding: 6px 0;
    overflow: hidden;
 }
.p-pointer{ 
    cursor:pointer;
}
</style>